import Vue from 'vue';
import Vuex from 'vuex';
import TokenStorage from "../common/TokenStorage";
import MemberStorage from "../common/MemberStorage";
import MobileStorage from "../common/MobileStorage";
import http from '../request/http'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: TokenStorage.getToken(),
    userInfo: null,
    members: [],
    device: {},
    selectMemberId: MemberStorage.getSelectMemberId(),
    isIgnoreMobile: MobileStorage.isIgnore()
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      TokenStorage.setToken(token);
    },

    setUserInfo(state, userInfo) {
      state.userInfo = userInfo || {};
    },

    setUserDeviceId(state, deviceId) {
      state.userInfo.deviceId = deviceId;
    },

    setMobile(state, mobile) {
      state.userInfo.mobile = mobile;
    },

    setMembers(state, members) {
      state.members = members || [];
      if (members && members.length > 0) {
        let index = members.findIndex(item => item.id === state.selectMemberId);
        if (index < 0) {
          state.selectMemberId = members[0].id;
          MemberStorage.setSelectMemberId(state.selectMemberId );
        }
      }
    },

    setDevice(state, device) {
      state.device = device || {};
      if (state.userInfo && !state.userInfo.deviceId && device) {
        state.userInfo.deviceId = device.id;
      }
    },

    setSelectMemberId(state, memberId) {
      state.selectMemberId = memberId;
      MemberStorage.setSelectMemberId(memberId);
    },

    setIgnoreMobile(state, isIgnore) {
      state.isIgnoreMobile = isIgnore;
      MobileStorage.setIgnore(isIgnore);
    }
  },
  getters: {
    curMember(state) {
      if (state.members.length > 0) {
        return state.members.find(item => item.id === state.selectMemberId);
      } else {
        return null;
      }
    }
  },
  actions: {
    async getUserInfo({commit}) {
      let [{data: userInfo}, {data: members}, {data: device}] = await Promise.all([
        http.getUserInfo(),
        http.getMembers(),
        http.getDevice()
      ]);
      commit('setUserInfo', userInfo);
      commit('setMembers', members);
      commit('setDevice', device);
      return {
        ...userInfo
      }
    },

    async getMembers({commit}) {
      let {data} = await http.getMembers();
      commit('setMembers', data);
      return data;
    },

    async getDevice({commit}, options) {
      let {data} = await http.getDevice({}, options);
      commit('setDevice', data);
      return data;
    }
  },
  modules: {
  }
})
